import React, { useState, useEffect } from 'react';
import QuoteBuilderForm from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderForm.jsx';

const Lamination = ({ config, disabled, options, uuid, item, extra_item_title, getExtraItems, navSection, colIndex, rowIndex, disabledReason, navSectionColumnType}) => {
  return (
    <QuoteBuilderForm
      config={config.lamination}
      disabled={disabled}
      disabledReason={disabledReason}
      options={options}
      section_uuid={uuid}
      navSectionColumnType={navSectionColumnType}
      item={item}
      extra_title={extra_item_title}
      getExtraItems={getExtraItems}
      navSection={navSection}
      colIndex={colIndex}
      rowIndex={rowIndex}
    />
  )
}

export default Lamination;
